import React from "react";
import { connect } from "react-redux";

function Dashboard() {
  return <span>Dashboard</span>
}

export default connect(({ authentication }) => ({ authentication }))(Dashboard);
